export const SectionCards = ({ sections, active, onSelect, gridClass = "grid-cols-1 md:grid-cols-2" }) => (
  <div className={`grid ${gridClass} gap-4 mb-10 animate-fade-up`}>
    {sections.map((s) => {
      const Icon = s.icon;
      const isActive = active === s.id;
      return (
        <button key={s.id} type="button" onClick={() => onSelect(s)}
          data-testid={s.testId || `section-card-${s.id}`}
          style={{ "--sec-color": s.color }}
          className={`text-left p-5 rounded-2xl border backdrop-blur-md transition-all duration-300 ${
            isActive
              ? "bg-white/[0.07] border-[var(--sec-color)] shadow-[0_10px_36px_-14px_var(--sec-color)]"
              : "bg-white/[0.03] border-white/10 hover:border-white/25 hover:-translate-y-0.5"
          }`}>
          <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl mb-3"
            style={{ backgroundColor: `${s.color}1A` }}>
            <Icon size={24} weight="duotone" style={{ color: s.color }} />
          </span>
          <h3 className="font-heading text-lg font-semibold tracking-tight" style={isActive ? { color: s.color } : undefined}>
            {s.title}
          </h3>
          <p className="text-xs text-white/50 mt-1">{s.desc}</p>
        </button>
      );
    })}
  </div>
);
